import React, { ReactNode } from 'react'
import Header from '../landing/Header'
import Footer from '../landing/Footer'

interface AuthPageLayoutProps {
  children: ReactNode
}

export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center py-16 px-4">
        <div className="w-full max-w-lg lg:max-w-xl xl:max-w-2xl">
          <div className="bg-white py-8 px-4 shadow-xl ring-1 ring-gray-900/10 sm:rounded-lg sm:px-10 dark:bg-white dark:text-gray-900">
            <div className="-mt-8">
              {children}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
} 